import type { ReactNode } from "react";

interface TagProps {
  children: ReactNode;
  tone?: "accent" | "secondary" | "primary";
}

const toneMap = {
  accent: "bg-accent-500/15 text-accent-400 border border-accent-500/30",
  secondary: "bg-secondary-900/50 text-secondary-400 border border-secondary-800/60",
  primary: "bg-primary-500/15 text-primary-300 border border-primary-500/30",
};

export default function Tag({ children, tone = "secondary" }: TagProps) {
  return (
    <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-label tracking-wide whitespace-nowrap ${toneMap[tone]}`}>
      {children}
    </span>
  );
}